module.exports = __webpack_public_path__ + "media/images/buttons/browse_hover-7a75d3bf5cca2c2dce92a795b3659d4f.png";